<div class="analytics-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo mobile-hidden" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <h3 class="my-5 mobile-hidden">{{ _translateService.Keys.ANALYTICS_TITLE | translate }}</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content">
            <div class="table-cont fixed">
                <label>{{ _translateService.Keys.ANALYTICS_SUMMARY | translate }}</label>
                <div class="main-content-block">
                    <div class="table-wrapper">
                        <table mat-table [dataSource]="lossRatio">
                        <ng-container matColumnDef="scac">
                            <th mat-header-cell *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_SCAC | translate }}</th>
                            <td mat-cell *matCellDef="let element"> {{element.scac}} </td>
                        </ng-container>
                        <ng-container matColumnDef="afpName">
                            <th mat-header-cell *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_AFP_NAME | translate }}</th>
                            <td mat-cell *matCellDef="let element"> {{element.afpName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="incidents">
                            <th mat-header-cell *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_INCIDENTS | translate }}</th>
                            <td mat-cell *matCellDef="let element"> {{element.incidents}} </td>
                        </ng-container>
                        <ng-container matColumnDef="netIncurred">
                            <th mat-header-cell *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_INCURRED | translate }}</th>
                            <td mat-cell *matCellDef="let element"> {{element.netIncurred | currency: currentCurrency: 'symbol': '1.2-2': currentLocale}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedLossRatioColumns"></tr>
                        <tr mat-row class="table-row" *matRowDef="let row; columns: displayedLossRatioColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell noData text-center" colspan="10">{{ _translateService.Keys.COMMON_NO_DATA | translate }}</td>
                        </tr>
                    </table>
                    </div>

                    <div class="value-date" *ngIf="valueDate">
                        <strong>{{ _translateService.Keys.ANALYTICS_VALUE_DATE | translate }}:</strong> {{ valueDate | date: dateFormat: currentLocale }}
                    </div>
                </div>
            </div>
            
            <div class="table-cont">
                <div class="searchBar">
                    <input
                        id="search"
                        class="form-input"
                        placeholder="{{ _translateService.Keys.COMMON_SEARCH | translate }}"
                        (keyup)="applyClaimsFilter()"
                        [(ngModel)]="claimsGridFilterValue"
                        spellcheck="false"
                    />
                    <button
                        *ngIf="claimsGridFilterValue && claimsGridFilterValue.length > 0"
                        class="clear-search-btn"
                        (click)="clearSearch()"
                        type="button"
                    >
                        <img src="../../../assets/close.svg" alt="clear search" width="16" height="16">
                    </button>
                    <label
                        for="search"
                        class="form_label"
                    >{{ _translateService.Keys.COMMON_SEARCH | translate }}
                    </label>
                </div>
                <label>{{ _translateService.Keys.ANALYTICS_CLAIMS | translate }}</label>
                <div class="table-wrapper">
                    <table #claimsTable="matSort" mat-table matSort [dataSource]="claims" 
                    matSortActive="dateOfLoss" matSortDirection="desc">
                    <ng-container matColumnDef="claimNumber">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_CLAIM_NUMBER | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.claimNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="dateOfLoss">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_DATE_OF_LOSS | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.dateOfLoss | date: dateFormat: currentLocale}} </td>
                    </ng-container>
                    <ng-container matColumnDef="claimStatus">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_CLAIM_STATUS | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.claimStatus}} </td>
                    </ng-container>
                    <ng-container matColumnDef="netIncurred">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_INCURRED | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.netIncurred | currency: currentCurrency: 'symbol': '1.2-2': currentLocale}} </td>
                    </ng-container>
                    <ng-container matColumnDef="coverage">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_COVERAGE | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.coverage}} </td>
                    </ng-container>
                    <ng-container matColumnDef="amazonId">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_AMAZON_ID | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.amazonId}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lossDescription">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.ANALYTICS_LOSS_DESCRIPTION | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.lossDescription}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedClaimsColumns"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: displayedClaimsColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell noData text-center" colspan="10">{{ _translateService.Keys.VERIFICATION_TRACTORS_NO_DATA_FILTER | translate: {filter: claimsGridFilterValue} }}</td>
                    </tr>
                </table>
                </div>
            </div>
            <div class="actions pt-3 mobile-hidden">
                <button class="primary-button"
                    [routerLink]="['/coverage']"
                    [queryParams]="{ qnum: qnum, qsuffix: qsuffix }">
                    {{ _translateService.Keys.COMMON_BACK | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
